module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="card">\n    <div class="card-header ' +
((__t = (panelCss)) == null ? '' : __t) +
'">\n        <h3 class="DescartesUIPanelTitle card-title">' +
((__t = (requiredParamsFielset)) == null ? '' : __t) +
'</h3>\n    </div>\n    <div class="card-body">\n        <div class="form-group row">\n            <label class="DescartesUILabel col-sm-4 col-form-label">' +
((__t = (titleInput)) == null ? '' : __t) +
'</label>\n            <div class="col-sm-8">\n                <input name="title" type="text" class="DescartesUIInput form-control" required="true" value="' +
((__t = (title)) == null ? '' : __t) +
'">\n            </div>\n        </div>\n        <div class="form-group row">\n            <label class="DescartesUILabel col-sm-4 col-form-label">' +
((__t = (layernameInput)) == null ? '' : __t) +
'</label>\n            <div class="col-sm-8">\n                <input name="layerName" type="text" class="DescartesUIInput form-control" required="true" value="' +
((__t = (layerName)) == null ? '' : __t) +
'">\n            </div>\n        </div>\n        <div class="form-group row">\n            <label class="DescartesUILabel col-sm-4 col-form-label">' +
((__t = (serverInput)) == null ? '' : __t) +
'</label>\n            <div class="col-sm-8">\n                <input name="urlserver" type="text" class="DescartesUIInput form-control" required="true" value="' +
((__t = (urlserver)) == null ? '' : __t) +
'">\n            </div>\n        </div>\n    </div>\n</div>\n\n<div class="card">\n    <div class="card-header ' +
((__t = (panelCss)) == null ? '' : __t) +
'">\n        <h3 class="DescartesUIPanelTitle card-title">' +
((__t = (optionalParamsFielset)) == null ? '' : __t) +
'</h3>\n    </div>\n    <div class="card-body">\n        <div class="form-group row">\n            <label class="DescartesUILabel col-sm-4 col-form-label">' +
((__t = (typeInput)) == null ? '' : __t) +
'</label>\n            <div class="col-sm-8">\n                <p class="DescartesUIText form-control-static">' +
((__t = (type)) == null ? '' : __t) +
'</p>\n            </div>\n        </div>\n        <div class="form-group row">\n            <label class="DescartesUILabel col-sm-4 col-form-label">' +
((__t = (versionInput)) == null ? '' : __t) +
'</label>\n            <div class="col-sm-8">\n                <input name="version" type="text" class="DescartesUIInput form-control" value="' +
((__t = (version)) == null ? '' : __t) +
'">\n            </div>\n        </div>\n        <div class="form-group row">\n            <label class="DescartesUILabel col-sm-4 col-form-label">' +
((__t = (stylesInput)) == null ? '' : __t) +
'</label>\n            <div class="col-sm-8">\n                <input name="styles" type="text" class="DescartesUIInput form-control" value="' +
((__t = (styles)) == null ? '' : __t) +
'">\n            </div>\n        </div>\n        <div class="form-group row">\n            <label class="DescartesUILabel col-sm-4 col-form-label">' +
((__t = (formatInput)) == null ? '' : __t) +
'</label>\n            <div class="col-sm-8">\n                <select class="DescartesUISelect form-control" name="format">\n                    ';

                        _.each(formats,function(aFormat) {
                            var out = '<option value="';
                            out += aFormat.value;
                            out += '"';
                            if(format===aFormat.value) {
                                out += 'selected';
                            }
                            out += '>';
                            out += aFormat.text;
                            out += '</option>';
                            print(out);
                        });
                    ;
__p += '\n                </select>\n            </div>\n        </div>\n        <div class="form-group row">\n            <label class="DescartesUILabel col-sm-4 col-form-label">' +
((__t = (legendInput)) == null ? '' : __t) +
'</label>\n            <div class="col-sm-8">\n                <input name="legend" type="text" class="DescartesUIInput form-control" value="' +
((__t = (legend)) == null ? '' : __t) +
'">\n            </div>\n        </div>\n        <div class="form-group row">\n            <label class="DescartesUILabel col-sm-4 col-form-label">' +
((__t = (metadataUrlInput)) == null ? '' : __t) +
'</label>\n            <div class="col-sm-8">\n                <input name="metadataURL" type="text" class="DescartesUIInput form-control" value="' +
((__t = (metadataURL)) == null ? '' : __t) +
'">\n            </div>\n        </div>\n    </div>\n</div>\n\n<div class="card">\n    <div class="card-header ' +
((__t = (panelCss)) == null ? '' : __t) +
'">\n        <h3 class="DescartesUIPanelTitle card-title">' +
((__t = (optionsFielset)) == null ? '' : __t) +
'</h3>\n    </div>\n    <div class="card-body">\n        <div class="form-group row">\n            <label class="DescartesUILabel col-sm-4 col-form-label">' +
((__t = (queryableInput)) == null ? '' : __t) +
'</label>\n            <div class="col-sm-8">\n                <label class="checkbox-inline">\n                    <input type="hidden" name="queryable" value="false"/>\n                    <input type="checkbox" name="queryable" value="true" ';
if(queryable==true){print('checked');};
__p += '>&nbsp;\n                </label>\n            </div>\n        </div>\n        <div class="form-group row">\n            <label class="DescartesUILabel col-sm-4 col-form-label">' +
((__t = (sheetableInput)) == null ? '' : __t) +
'</label>\n            <div class="col-sm-8">\n                <label class="checkbox-inline">\n                    <input type="hidden" name="sheetable" value="false" />\n                    <input type="checkbox" name="sheetable" value="true" ';
if(sheetable==true){print('checked');};
__p += '>&nbsp;\n                </label>\n            </div>\n        </div>\n        <div class="form-group row">\n            <label class="DescartesUILabel col-sm-4 col-form-label">' +
((__t = (maxScaleInput)) == null ? '' : __t) +
'</label>\n            <div class="col-sm-8">\n                <input name="maxScale" type="text" class="DescartesUIInput form-control" value="' +
((__t = (maxScale)) == null ? '' : __t) +
'">\n            </div>\n        </div>\n        <div class="form-group row">\n            <label class="DescartesUILabel col-sm-4 col-form-label">' +
((__t = (minScaleInput)) == null ? '' : __t) +
'</label>\n            <div class="col-sm-8">\n                <input name="minScale" type="text" class="DescartesUIInput form-control" value="' +
((__t = (minScale)) == null ? '' : __t) +
'">\n            </div>\n        </div>\n    </div>\n</div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/DMap/Button/ContentTask/bootstrap4/templates/AbstractEditLayer.ejs
// module id = 403
// module chunks = 0